import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications } from '../helpers';
import { DeleteEventDocument } from './delete.generated';

export const useDeleteEvent = () => {
  const { t } = useTranslation();
  return useMutation(DeleteEventDocument, {
    ...useNotifications(DeleteEventDocument, {
      failure: t('api.common.error_generic'),
      success: (data) => {
        const count = data.deleteEvent?.deletedIds.length ?? 0;
        return t('api.events.delete_success_plural', { count });
      },
    }),
    update(cache, { data }) {
      if (!data?.deleteEvent?.deletedIds.length) return;
      data.deleteEvent.deletedIds.forEach((id) => cache.evict({ id: `Event:${id}` }));
    },
  });
};
